export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
export const PEC_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
export const VAT_NUMBER_REGEX = /^[0-9]{11}$/;
export const TAX_CODE_REGEX = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
export const PHONE_REGEX = /^[0-9+()\s-]{5,20}$/;

/** Valida una stringa con una o più email/PEC separate da virgola (ogni parte viene trimmata). */
export function validateMultipleEmails(
  value: string | undefined | null,
  regex: RegExp
): boolean {
  if (value === undefined || value === null) return true;
  const trimmed = value.trim();
  if (trimmed === '') return true;
  const parts = trimmed.split(',').map(p => p.trim()).filter(Boolean);
  return parts.every(part => regex.test(part));
}

/** Valida una stringa con uno o più numeri di telefono separati da virgola (ogni parte viene trimmata). */
export function validateMultiplePhones(
  value: string | undefined | null,
  regex: RegExp = PHONE_REGEX
): boolean {
  if (value === undefined || value === null) return true;
  const trimmed = value.trim();
  if (trimmed === '') return true;
  const parts = trimmed.split(',').map(p => p.trim()).filter(Boolean);
  return parts.every(part => regex.test(part));
}
